import styled from 'styled-components';

import { FlexDiv } from '@shared/components/base/Div';
import { DefaultScrollBar } from '@shared/components/styles/ScrollBar';

export const Wrapper = styled(FlexDiv)`
    flex-direction: column;
    max-height: 250px;
    overflow: auto;
    margin: 16px 20px;

    ${DefaultScrollBar}
`;
